import loadable from '@loadable/component';
import React from 'react';
import { Loading } from '../../components/Loading';
import { useUser } from '../../hooks/useUser';

const AccountRequestReturnPage = loadable(() => import('../AccountRequestReturnPage'), {
  fallback: <Loading />
});

const GuestRequestReturnPage = loadable(() => import('../GuestRequestReturnPage'), {
  fallback: <Loading />
});

export const RequestReturnPage = () => {
  const {
    user: { isLoggedIn }
  } = useUser();

  if (isLoggedIn) {
    return <AccountRequestReturnPage />;
  }

  return <GuestRequestReturnPage />;
};
